import { Pencil } from 'lucide-react';

import { Button } from '@/components/Button/Button';

import type { UserRole } from './useCourse';

interface EditCourseButtonProps {
  courseId?: string;
  isEditing: boolean;
  onEdit(): void;
  userRole: UserRole;
}

export function EditCourseButton({
  courseId,
  isEditing,
  onEdit,
  userRole,
}: EditCourseButtonProps) {
  if (userRole !== 'instructor' || isEditing || !courseId) {
    return null;
  }

  return (
    <Button onClick={onEdit} size="large" variant="secondary">
      <Pencil aria-hidden="true" size={16} strokeWidth={2.4} />
      Edit course
    </Button>
  );
}
